import { useCallback, useEffect } from "react";
import cn from "classnames";
import { searchFilterStore } from "entities/SearchFilter";
import { useKeypress } from "shared/hooks/useKeypress.hook";
import { useAppSelector } from "shared/lib/redux";
import { Button } from "shared/ui/Button";
import { FilterIcon } from "shared/ui/Icons/Icons";
import { FilterContent } from "./components/FilterContent";
import styles from "./Filter.module.scss";

import { useFilterContext } from "./context/Filter.context";

type FilterProps = {
  className?: string;
  filterContentClassName?: string;
};

export const Filter: RFC<FilterProps> = ({ className, filterContentClassName }) => {
  const shipment = useAppSelector(searchFilterStore.selectors.shipment);
  const { setOpenFilter, isOpenFilter } = useFilterContext();

  const closeFilter = useCallback(() => {
    setOpenFilter(false);
  }, []);

  useEffect(() => {
    if (isOpenFilter) setOpenFilter((prev) => !prev);
  }, [shipment]);

  useKeypress("Escape", closeFilter);

  return (
    <div className={cn(styles.filter, className)}>
      <span>
        <Button
          data-test-id="filter-button"
          onClick={() => {
            setOpenFilter((prev) => !prev);
          }}
          className={cn(styles.button, { [styles.isOpenFilter]: isOpenFilter })}
          variant="secondary"
        >
          <FilterIcon />
        </Button>
        {isOpenFilter && <FilterContent closeFilter={closeFilter} classNames={filterContentClassName} />}
      </span>
    </div>
  );
};
